import { render, staticRenderFns } from "./materialPage.vue?vue&type=template&id=4d3ce33b&scoped=true"
import script from "./materialPage.vue?vue&type=script&lang=js"
export * from "./materialPage.vue?vue&type=script&lang=js"
import style0 from "./materialPage.vue?vue&type=style&index=0&id=4d3ce33b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3ce33b",
  null
  
)

export default component.exports